<template>
  <div class="card-content">
    <div class="row align-items-center">
      <div class="col-md-7">
        <div class="pr-md-3">
          <h3 class="title title--main">
            {{ data.name }}
          </h3>
          <div
            v-if="data.description"
            class="text mt-1 mt-lg-2"
            v-html="data.description"
          ></div>
        </div>
      </div>
      <div class="col-md-5 mt-3 mt-md-0">
        <button
          class="button button--primary w-100"
          @click="emitSelectedService(data)"
        >
          <span class="button__text">Seleccionar servicio</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardContent',
  props: {
    data: {
      type: Object,
      default: null,
      required: true,
    },
  },
  methods: {
    emitSelectedService(data) {
      this.$emit('set-service', data);
    },
  },
};
</script>

<style></style>
